import React, { useState } from "react";
import { CheckPicker } from "rsuite";

const CustomCheckPicker = ({
  options,
  formdata,
  field,
  formChangeHandler,
  checkPickerHandlerAll,
  apiUrl,
  onOpen,
}) => {
  const [searchHandle, isSetSearchHandle] = useState("");

  const handlerSearching = (e) => {
    isSetSearchHandle(e);
  };

  if (apiUrl) {
    return (
      <CheckPicker
        data={options || []}
        value={formdata[field] || []}
        onSearch={handlerSearching}
        onOpen={(e) => onOpen(e, apiUrl)}
        onChange={(val) => formChangeHandler(field)(val, options)}
        block={true}
        renderMenu={(menu) => (
          <div>
            {/* Custom "Select All" checkbox at the top */}
            <div
              style={{
                marginLeft: 8,
                padding: 5,
                borderBottom: "1px solid #e5e5e5",
                alignItems: "center",
                display: "flex",
                gap: 10,
              }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                name={field}
                checked={formdata[field]?.length === options.length} // Update based on selected items
                onChange={(e) => checkPickerHandlerAll(e, options)}
                disabled={searchHandle}
              />
              <label>Select All</label>
            </div>
            {/* Render the default menu items */}
            {menu}
          </div>
        )}
      />
    );
  }
  return (
    <CheckPicker
      data={options || []}
      value={formdata[field] || []}
      onSearch={handlerSearching}
      onChange={(val) => formChangeHandler(field)(val, options)}
      block={true}
      renderMenu={(menu) => (
        <div>
          {/* Custom "Select All" checkbox at the top */}
          <div
            style={{
              marginLeft: 8,
              padding: 5,
              borderBottom: "1px solid #e5e5e5",
              alignItems: "center",
              display: "flex",
              gap: 10,
            }}
          >
            <input
              type="checkbox"
              className="form-check-input"
              name={field}
              checked={formdata[field]?.length === options.length} // Update based on selected items
              onChange={(e) => checkPickerHandlerAll(e, options)}
              disabled={searchHandle}
            />
            <label>Select All</label>
          </div>
          {/* Render the default menu items */}
          {menu}
        </div>
      )}
    />
  );
};

export default CustomCheckPicker;
